import {createContext} from 'react'
import {BanModalHandler} from 'types'

export const BanModalContext = createContext<BanModalHandler | undefined>(
  undefined,
)
